import { TransactionDetail } from './transaction-detail';
import { TransactionDetailPaymentsDto } from './transaction-detail-payments-dto';

export class TransactionSummary {

    refNo: number;
    transactionDate: string;
    date: string;
    voucherType: string;
    documentRefNo: string;
    narration: string;
    fromLocationCode: number;
    transactionDetailPayments: TransactionDetailPaymentsDto[]=[];
    transactionDetails: TransactionDetail[]=[];

    module: string;
}
